import QRCode from 'qrcode';

/**
 * Standalone QR PNG for an artist's public page, for artists doing their own layouts.
 * @param {string} publicUrl
 * @param {number} [width=720] square pixel size
 * @returns {Promise<Blob>}
 */
export async function buildArtistPublicQrPngBlob(publicUrl, width = 720) {
  if (!publicUrl || typeof publicUrl !== 'string') {
    throw new Error('buildArtistPublicQrPngBlob: publicUrl required');
  }
  const canvas = document.createElement('canvas');
  await QRCode.toCanvas(canvas, publicUrl, {
    width,
    margin: 2,
    color: { dark: '#0f172a', light: '#ffffff' },
  });
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) reject(new Error('QR PNG export failed'));
        else resolve(blob);
      },
      'image/png',
      1
    );
  });
}

export function triggerPngBlobDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
